<div class="main-div"></div>
<div class="overlay" *ngIf="loading">
    <div class="center">
        <mat-spinner class="custom-spinner"></mat-spinner>
    </div>
</div>

<div class="login-wrapper">
    <mat-card class="login-card">
        <mat-card-content>
            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                <div class="field-wrap">
                    <mat-form-field class="full-width" appearance="fill">
                        <mat-label>User Name</mat-label>
                        <input matInput
                               type="text"
                               name="username"
                               id="username"
                               formControlName="username"
                               required>
                        <mat-error *ngIf="username?.hasError('required')">
                            Username is required
                        </mat-error>
                        <mat-error *ngIf="username?.hasError('invalidUsername')">
                            Invalid username
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="field-wrap">
                    <mat-form-field class="full-width" appearance="fill">
                        <mat-label>Password</mat-label>
                        <input matInput
                               [type]="hidePassword ? 'password' : 'text'"
                               formControlName="password"
                               placeholder="Password">
                        <button mat-icon-button
                                matSuffix
                                (click)="hidePassword = !hidePassword"
                                type="button">
                            <mat-icon>
                                {{ hidePassword ? 'visibility_off' : 'visibility' }}
                            </mat-icon>
                        </button>
                    </mat-form-field>
                </div>

                <mat-card-actions class="login-actions">
                    <button mat-raised-button
                            type="submit"
                            color="primary"
                            class="full-width">
                        Sign in with Cypher account
                    </button>
                </mat-card-actions>

                <div class="sso-section" *ngIf="showMicrosoftLogin">
                    <button mat-stroked-button
                            type="button"
                            class="full-width microsoft-button"
                            (click)="onSsoLogin()">
                        <span class="microsoft-content">
                            <span class="microsoft-logo" aria-hidden="true">
                                <span class="tile red"></span>
                                <span class="tile green"></span>
                                <span class="tile blue"></span>
                                <span class="tile yellow"></span>
                            </span>
                            <span class="microsoft-text">
                                Continue with Microsoft
                            </span>
                        </span>
                    </button>
                </div>
            </form>

            <div *ngIf="error" class="error-message">
                {{ error }}
            </div>
        </mat-card-content>
    </mat-card>
</div>
